import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Ripple } from './components/magicui/ripple'

export const AuthWrapper = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loginWithRedirect, isLoading, error } = useAuth0()

  useEffect(() => {
    if (isLoading || isAuthenticated) return

    const handleLogin = async () => {
      try {
        const returnTo = `${window.location.pathname}${window.location.search}`
        await loginWithRedirect({
          appState: { returnTo },
          authorizationParams: {
            redirect_uri: window.location.origin,
          },
        })
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Login redirect error:', err)
      }
    }

    handleLogin()
  }, [isAuthenticated, isLoading, loginWithRedirect])

  if (isLoading) {
    return (
      <div className='fixed inset-0 flex items-center justify-center bg-background z-50 overflow-hidden'>
        <div className='relative h-full w-full flex items-center justify-center'>
          <Ripple />
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className='fixed inset-0 flex flex-col items-center justify-center bg-background z-50 gap-4 p-4'>
        <h2 className='text-2xl font-bold text-destructive'>
          Authentication Error
        </h2>
        <p className='text-muted-foreground'>{error.message}</p>
        <button
          onClick={() => window.location.reload()}
          className='mt-4 px-4 py-2 text-sm text-primary rounded-md bg-primary/10 hover:bg-primary/20'
        >
          Retry
        </button>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <div className='fixed inset-0 flex items-center justify-center bg-background z-50 overflow-hidden'>
        <div className='relative h-full w-full flex items-center justify-center'>
          <Ripple />
        </div>
      </div>
    )
  }

  return <>{children}</>
}
